import React, { useEffect, useState } from 'react';
import paySuccess from '@/assets/imgs/applyRefundDetail/pay-success.png';
import payError from '@/assets/imgs/applyRefundDetail/pay-error.png';
import Icon from '@/assets/imgs/fudou.png';
import styles from './index.less';
import Api from '@/common/api';
import { TLang } from '@/utils/lang';
import NavBar from '@/components/NavBar';
import { router, withRouter } from 'umi';
import { unionFlag, getSessonStorage } from '@/utils';
import { connect } from 'dva';

const ApplyRefundDetail = ({unionConfig, location}) => {
  const [refundDetail, setRefundDetail] = useState<any>({});
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  const [union] = useState(unionCode && typeof unionCode !== 'undefined');

  useEffect(() => {
    const orderSn = location.query.orderSn;
    Api.getApplyRefundDetail({orderSn}).then((res) => {
      if (res) {
        setRefundDetail(res);
      }
    });
  }, []);

  const getPrice = (price): string => {
    if (union) {
      // price
      let p = (price / 100) * unionConfig.union_scale;
      return p.toFixed(2);
    } else {
      let p = price / 100;
      return p.toFixed(2);
    }
  };

  const goToOrderDetail = () => {
    router.go(-1);
  };
  return (
    <div className={styles.applyRefundDetail}>
      <NavBar isShowMenu showService={false} text={TLang('申请退款', 'home', false, false, null)} initColor="#333" targetColor="#333" targetBgColor="#FFF" opacity={1} />
      <div className={styles.applyRefundDetail_content}>
        <div className={styles.applyRefundDetail_image}>
          {refundDetail.applyResult
            ? <img src={paySuccess} alt="" />
            : <img src={payError} alt="" />
          }
        </div>
        <div className={styles.applyRefundDetail_text}>{refundDetail.applyResult ? `${TLang('申请退款中', 'home', false, false, null)}` : `${TLang('申请失败', 'home', false, false, null)}`}</div>
        {refundDetail.applyResult
          ?<div className={styles.applyRefundDetail_price}>
            <span className={styles.text}>{TLang('实退', 'home', false, false, null)}</span>
            {refundDetail?.count > 0 && <span  className={styles.price}>{refundDetail?.count + '次'}</span>}
            {refundDetail?.count > 0 && refundDetail?.price > 0 && <span className={styles.price}> + </span>}
            {refundDetail?.count > 0 && refundDetail?.price > 0 && <img src={Icon} alt="" />}
            {refundDetail?.count > 0
              ? (refundDetail?.price > 0 && <span className={styles.price}>{(refundDetail?.price / 100).toFixed(2)}</span>)
              : <span className={styles.price}>{getPrice(refundDetail?.refundAmount)}</span>
            }
          </div>
          : <div className={styles.applyRefundDetail_reason}>
            {refundDetail.failReason}
          </div>
        }
        <div className={styles.applyRefundDetail_button} onClick={() => goToOrderDetail()}>
          {TLang('查看退款详情', 'home', false, false, null)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default withRouter(connect(mapStateToProps)(ApplyRefundDetail));
